import Bulldozer from "./illustrations/Bricks.js";
import Construction from "./illustrations/Construction.js";
//#region src/components/illustrations.jsx
const Illustration = {
	Bricks: Bulldozer,
	Construction
};
//#endregion
export { Construction, Illustration };

//# sourceMappingURL=illustrations.js.map